import React, { useMemo, useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import { editDetails } from "../../../store/reducers/authReducer";

const EditTables = ({ init }) => {
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    let s;
    let a;
    let c;
    let sh;
    let newArray = [];

    for (let i = 0; i < user.tablesArray.length; i++) {
      s = i + "title";
      a = i + "amount";
      c = i + "chairs";
      sh = i + "shape";
      newArray.push({
        ...user.tablesArray[i],
        amount: parseInt(data[a]),
        chairs: parseInt(data[c]),
        title: data[s],
        shape: data[sh] || "square",
      });
    }
    setLoading(true);
    dispatch(editDetails({ tablesArray: [...newArray] })).then((res) => {
      setLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  let tablesArray = useMemo(() => {
    let tables = [];
    if (user.tablesArray.length > 0) {
      let s;
      let a;
      let c;
      for (let i = 0; i < user.tablesArray.length; i++) {
        s = i + "title";
        a = i + "amount";
        c = i + "chairs";
        tables.push(
          <FlexRowBetween
            key={i}
            style={{
              marginTop: "10px",
            }}
          >
            <div>{i + 1})</div>
            <div style={{ width: "40%" }}>
              <Label>כותרת</Label>
              <Input
                type="text"
                placeholder="כותרת"
                defaultValue={user.tablesArray[i].title}
                {...register(s, {
                  required: true,
                  minLength: 1,
                  maxLength: 50,
                })}
              />
              {CFV(s, "מספר בין 1 ל 50", errors)}
            </div>
            <div style={{ width: "12%" }}>
              <Label>מכיל</Label>
              <Input
                type="number"
                defaultValue={user.tablesArray[i].amount}
                {...register(a, {
                  required: true,
                  min: 0,
                  max: 300,
                })}
              />
              {CFV(a, `מספר בין 0 ל 300`, errors)}
            </div>
            <div style={{ width: "12%" }}>
              <Label>ערוך</Label>
              <Input
                type="number"
                defaultValue={
                  user.tablesArray[i].chairs || user.tablesArray[i].amount
                }
                {...register(c, {
                  required: true,
                  min: 0,
                  max: 300,
                })}
              />
              {CFV(c, `מספר בין 0 ל 300`, errors)}
            </div>
            <div style={{ width: "12%" }}>
              <Label>צורה</Label>
              <select
                defaultValue={user.tablesArray[i].shape || "square"}
                {...register(i + "shape", {
                  required: true,
                })}
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: 4,
                  fontSize: "14px",
                }}
              >
                <option value="square">ריבועי</option>
                <option value="circle">עגול</option>
              </select>
            </div>
            <br />
          </FlexRowBetween>
        );
      }
    }

    return [tables];
  }, [user.tablesArray]);

  let height = window.screen.availHeight;
  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ height: "min-content", maxHeight: `${height * 0.75}px` }}
    >
      <div
        style={{
          width: "96%",
          margin: "15px auto",
        }}
      >
        {tablesArray[0]}

        <FlexRowBetween style={{ marginTop: "30px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default EditTables;
